<template>
  <div class="mainWrapper" :class="{'headShow':!(fromRes=='banner')}">
    <VHeader :toList='ToList' :from='fromDetail' v-if="fromRes=='banner'"></VHeader>
    <div class="contentBody" :class="{'suitIOS':!ISANDROID}" ref="mainRef">
      <div class="content">
        <p class="title">{{dTitle}}</p>
        <p class="fTitle"><span class="dfrom">{{dFrom}}</span><span class="depart">{{depart}}</span><span
            class="dtime">{{dTime}}</span></p>
        <div class="dContent" v-html="Dontent">
        </div>
        <myVideo v-for="(item) in finalVideo" :url='item.vidoUrl' :imgUr='item.videoImg' :key="item.uid"></myVideo>
        <div class="imageWrapper" v-for="(item1, index1) in imageArrUrl" :key="index1">
          <div class="imageContent">
            <!-- <img class="img" :src="item1.picUrl" v-loads='item1.picUrl' alt=""> -->
            <img class="img" v-loads='item1.picUrl' alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VHeader from "@/components/VHeader";
  import myVideo from "@/components/myVideo";
  import axios from "axios";
  import BScroll from "better-scroll";
  import { detailInfoUrl } from "@/tools/address";
  import { getUserInfo, backToLogin } from '@/tools/isAndroid';
  export default {
    name: "BannerDetail",
    data() {
      return {
        detailUrl: detailInfoUrl,
        dTitle: "",
        dFrom: "",
        dTime: "",
        depart: "",
        Dontent: "",
        imageArrUrl: [],
        ToList: false, // 隐藏进入列表的按钮
        finalVideo: [],
        fromDetail: "detail",
        fromRes: "banner"
      };
    },
    directives: {
      loads: {
        bind: function (el, binding, vnode) {
          // console.log(el, binding, vnode)
          var img = new Image();
          img.src = binding.value;
          var that = vnode.context;
          img.onload = function () {
            img.onload = null;
            el.src = img.src;
            setTimeout(() => {
              that._initialScroll();
            }, 50);
          }
        }
      }
    },
    created() { },
    mounted() {
      this.fromRes = this.$route.query.from;
      let detailId = this.$route.query.id;
      let userInfos = getUserInfo();
      axios
        .get(this.detailUrl, {
          params: {
            id: detailId,
            userId: userInfos.userId,
            sessionId: userInfos.sessionId,
            casCookie: userInfos.casCookie
          }
        })
        .then(res => {
          // backToLogin(res.data)
          if (res.status == 200 && !res.data.errorCode) {
            this.dTitle = res.data.data.adTitle;
            this.dFrom = res.data.data.adOrgName;
            this.dTime = res.data.data.startTime;
            this.Dontent = res.data.data.adContent;
            this.imageArrUrl = res.data.data.contentImages;
            this.finalVideo = this.operObj(
              res.data.data.videosUrls,
              res.data.data.videoImages
            );
          }
          this.$nextTick(() => {
            this._initialScroll();
          })
        })
        .catch(err => { });
    },
    methods: {
      _initialScroll() {
        // console.log('initScroll');
        if (!this.mainWrapper) {
          this.mainWrapper = new BScroll(this.$refs.mainRef, {
            click: true
          });
        } else {
          this.mainWrapper.refresh();
        }
      },
      operObj(vedioArr, imgArr) {
        vedioArr.forEach((obj, index) => {
          if (
            imgArr &&
            imgArr[index] &&
            imgArr[index].picUrl &&
            imgArr[index].picUrl.length > 0
          ) {
            obj.videoImg = imgArr[index].picUrl;
          } else {
            obj.videoImg = "";
          }
        });
        return vedioArr;
      }
    },
    components: {
      VHeader,
      myVideo
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
  .contentBody {
    left: 0;
    right: 0;
    padding: 0 0.32rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/BannerDetail.vue